import PropTypes from 'prop-types';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import INFO_DATA from './constants';

import {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledContainer,
  StyledInfoOutlinedIcon,
  TypographyHeading,
} from './styledComponents';

const AccordionComponent = ({ type, customData }) => {
  const data = type ? INFO_DATA?.[type] : customData;
  return (
    <StyledContainer>
      <StyledAccordion elevation={0}>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          {type && <StyledInfoOutlinedIcon />}
          <TypographyHeading variant="h6">{data?.title}</TypographyHeading>
        </StyledAccordionSummary>
        <StyledAccordionDetails>{data?.body}</StyledAccordionDetails>
      </StyledAccordion>
    </StyledContainer>
  );
};
AccordionComponent.defaultProps = {
  type: null,
  customData: {},
};

AccordionComponent.propTypes = {
  type: PropTypes.string,
  customData: PropTypes.instanceOf(Object),
};

export default AccordionComponent;
